import React, { useEffect, useState } from 'react';
import './UndoToast.css';

interface UndoToastProps {
  message: string;
  onUndo: () => void;
  onClose: () => void;
  duration?: number; // in seconds
}

const UndoToast: React.FC<UndoToastProps> = ({
  message,
  onUndo,
  onClose,
  duration = 10
}) => {
  const [timeLeft, setTimeLeft] = useState(duration);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Countdown timer
    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          handleClose();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(onClose, 300); // Wait for animation
  };

  const handleUndo = () => {
    onUndo();
    handleClose();
  };

  const progressPercentage = (timeLeft / duration) * 100;

  return (
    <div className={`undo-toast ${isVisible ? 'visible' : 'hidden'}`}>
      <div className="toast-content">
        <div className="toast-icon">✅</div>
        <div className="toast-message">
          <p className="toast-text">{message}</p>
          <p className="toast-timer">Zostáva {timeLeft}s na vrátenie zmeny</p>
        </div>
        <div className="toast-actions">
          <button className="btn-undo" onClick={handleUndo}>
            ↶ Undo
          </button>
          <button className="btn-close-toast" onClick={handleClose}>
            ×
          </button>
        </div>
      </div>
      <div className="toast-progress">
        <div 
          className="toast-progress-bar" 
          style={{ width: `${progressPercentage}%` }}
        />
      </div>
    </div>
  );
};

export default UndoToast;

